import $ from 'jquery';
import { atcb_action } from 'add-to-calendar-button';

import { FireComponent } from '@base';

export class Event extends FireComponent {
  constructor(id) {
    super(id);
  }

  _atcb() {
    // update accessibility for add-to-calendar-button parts
    let atcbShadowRoot = document.querySelector('[atcb-button-id="atcb-btn-bux-atcb"]').shadowRoot;
    if (atcbShadowRoot) {
      let btn = atcbShadowRoot.querySelector('#atcb-btn-bux-atcb');
      btn.addEventListener('click', function () {
        setTimeout(() => {
          atcbShadowRoot.querySelector('#atcb-bgoverlay').setAttribute('aria-label', 'Close Add to Calendar Modal');
          atcbShadowRoot.querySelector('.atcb-list').removeAttribute('role');
        }, 500);
      });
    }
  }

  init() {
    if (!this.componentExists) return;

    this._atcb();
  }
}
